import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

export const createPortalNote = async (model: IPortalNoteModel, image?: any): Promise<IPortalNoteModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/portalnotes/addnote`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)

          axios
            .post(`/portalnotes/uploadimg?noteId=${res?.data?.data?.portalNoteId}`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: IPortalNoteModel
  image?: any
}

export const useCreatePortalNote = (notify?: boolean, onSuccess?: (data: IPortalNoteModel) => void) =>
  useMutation({
    mutationKey: ['createPortalNote'],
    mutationFn: ({ model, image }: Props) => createPortalNote(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created note.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create note, please try again.')
      }
    },
    throwOnError: false
  })
